import { useMemo } from 'react';
import Lottie from 'lottie-react';

import { cloneAnimationData } from '@/features/letterParty/helpers';

import polonaiseLetterTemplate from '@/features/letterParty/assets/lottie/polonaise-letter.json';

const WORD = 'letterfeestje';

const createLetterAnimation = (letter: string, template: any) => {
	const animationData = cloneAnimationData(template);

	if (animationData.assets?.[0]?.layers) {
		const textLayer = animationData.assets[0].layers.find((layer: any) => layer.nm === 'LETTER');

		if (textLayer?.t?.d?.k) {
			textLayer.t.d.k.forEach((keyframe: any) => {
				if (keyframe.s?.t !== undefined) {
					keyframe.s.t = letter;
				}
			});
		}
	}

	return animationData;
};

const PolonaiseLine = () => {
	const letters = useMemo(() => WORD.split(''), []);

	const letterAnimations = useMemo(() => {
		return letters.map((letter) => createLetterAnimation(letter, polonaiseLetterTemplate));
	}, [letters]);

	return (
		<div className="letter-party-game__polonaise-line">
			{letterAnimations.map((animationData, index) => (
				<div
					key={`${letters[index]}-${index}`}
					className="letter-party-game__polonaise-letter"
					style={{
						animationDelay: `${index * 0.05}s`,
					}}
				>
					<Lottie animationData={animationData} loop autoplay />
				</div>
			))}
		</div>
	);
};

export default PolonaiseLine;
